import Swiper from "swiper";
import { Navigation, Pagination, EffectFade } from "swiper/modules";

let Slider = {};

Slider.initSwiper = (object, params = {}) => {
	return new Swiper(object, {
		modules: [Navigation, Pagination, EffectFade],
		slidesPerView: 1,
		loop: false,
		...params,
	});
};

// Sliders Mobile : Activate only unde 768px
let $slidersMobile = document.querySelectorAll(".slider-mobile");
let swiperMobile = {};
let init = false;
const sliderMobile = (e) => {
	if (window.innerWidth <= 577) {
		if (!init) {
			init = true;
			swiperMobile = new Swiper(".slider-mobile", {
				modules: [Navigation],
				slidesPerView: 1,
				spaceBetween: 16,
				navigation: {
					nextEl: ".slider-mobile-button-next",
					prevEl: ".slider-mobile-button-prev",
				},
			});
		}
	} else if (init) {
		swiperMobile.forEach((slider) => {
			slider.destroy();
		});
		init = false;
	}
};

if ($slidersMobile.length > 0) {
	sliderMobile();
	window.addEventListener("resize", sliderMobile);
}

export default Slider;
